var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{key:_vm.$route.fullPath}),_c('div',{staticClass:"container",staticStyle:{"padding-top":"75px"}},[_c('NotificationsList'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }